module.exports = __webpack_public_path__ + "static/media/referrals-icon.a64da1bf.svg";